import intl from 'react-intl-universal'

export const isValidFields = (data, openFeedback) => {
  if (data.some(x => x.type === 'error')) {
    openFeedback(intl.get('master-data.configurations.imo-management.feedbacks.errorImoCode'))
    return false
  }
  return true;
}
